var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.414L1.414 0l7.293 7.293L16 0l1.414 1.414-7.293 7.293L17.414 16 16 17.414l-7.293-7.293-7.293 7.293L0 16l7.293-7.293L0 1.414z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxLjQxNDIxTDEuNDE0MjIgMEw4LjcwNzEyIDcuMjkyOTFMMTYgMEwxNy40MTQyIDEuNDE0MjFMMTAuMTIxMyA4LjcwNzEyTDE3LjQxNDIgMTUuOTk5OUwxNS45OTk5IDE3LjQxNDJMOC43MDcxMiAxMC4xMjEzTDEuNDE0MyAxNy40MTQyTDguOTA1OTNlLTA1IDE1Ljk5OTlMNy4yOTI5MSA4LjcwNzEyTDAgMS40MTQyMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };